<template>
    <div>
        <div v-for="(item) in items" :key="item.id" class="grid-item">
            <div class="card" :class="colorTipoAnuncio(item.tipoAnuncio)">
                <div class="body">

                    <small>Publicada el : {{item.fecha}} - {{item.hora}}</small>
                    <button class="download-button" v-if="item.noAnexo != 0" @click="downloadAnexo(item.noAnexo)">
                        <i class="ms-Icon ms-Icon--Attach"></i>
                    </button>
                    <div v-if="item.nuevo==1" class="badge badge-warning position-absolute nuevo-tablon">Nuevo <i
                            class="ms-Icon ms-Icon--6PointStar align-middle"></i></div>
                    <h5 class="card-title">{{item.titulo}}</h5>
                    <p v-html="item.texto"></p>
                    <div class="image" v-if="item.hayImagen">
                        <img :src="imagePath + item.id" class="w-100" @load="imagesLoaded++" />
                    </div>
                </div>
            </div>  
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { documentService } from '@/api/document';
export default {
    name: 'Items',
    components: {
        },
    data(){
        return {
            imagePath: Vue.prototype.$Params.urlBase + 'images/dashboard/',
            imagesLoaded: 0,
        }
    },
    props: {
        items: Array,
        tipos: Array
    },
    methods: {
        colorTipoAnuncio(tipo) {
            
            return `tipo${this.tipos.findIndex(x => x.tipoAnuncio===tipo)}`;
        },
        numImages() {
            return this.items.filter((item) => item.hayImagen==1).length;
        },
        emitLoaded() {
            let self = this;

            setTimeout(()=> {
                self.$emit('itemsLoaded');
            }, 150);
        },
        async downloadAnexo(idAnexo) {
                
            let dataAnexo = await documentService.downloadDashboard(idAnexo);
            
            if(dataAnexo) {
                //generacion de la descarga desde el navegador
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(new Blob([dataAnexo.file]))
                link.setAttribute('download', dataAnexo.name)
                document.body.appendChild(link)
                link.click();
            }
        },
    },
    watch: {
        imagesLoaded: function (v) {
            if(v == this.numImages()){
                this.emitLoaded();
            }
        },
        items: function() {
            if(this.items.length>0 && this.numImages()==0)
                this.emitLoaded();
        }
    },
}


</script>

<style>
.download-button {
    position: absolute; /* Position the button absolutely within the card */
    top: 10px; /* Adjust top position as needed */
    right: 10px; /* Adjust right position as needed */
    background: none; /* Remove default button background */
    border: none; /* Remove default button border */
    cursor: pointer; /* Add pointer cursor for better UX */
    font-size: 1.5em; /* Adjust icon size */
    color: #0078d4; /* Adjust icon color */
}

</style>